export enum AccessibilityStatusEnum {
  No = 0,
  Yes = 1,
  NeedsEvaluation = 2,
}

export const accessibilityStatusOptions = [
  {label: 'Yes', value: AccessibilityStatusEnum.Yes},
  {label: 'No', value: AccessibilityStatusEnum.No},
  {label: 'Needs Evaluation', value: AccessibilityStatusEnum.NeedsEvaluation},
];
